import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de fertilizantes Foliares
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function FertilizantesFoliares(props) {
  useEffect(() => {
    const title = 'fertilizantesFoliares.fertilizantesFoliares';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.FERTILIZANTE_FOLIAR}
      insumoURL='fertilizantes'
      viewKey='fertilizantesFoliares'
      deleteMessageSucess={formatMessage(
        'fertilizantesFoliares.fertilizantesFoliaresRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('fertilizantesFoliares.falhaAoExcluirFertilizantesFoliares')}
      mensagemDelete={formatMessage('fertilizantesFoliares.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'fertilizantesFoliares';
  })[0].content
});

export default connect(mapStateToProps)(FertilizantesFoliares);
